// extracted by mini-css-extract-plugin
module.exports = {"container":"social-share-widget_container__B91B9","socials":"social-share-widget_socials__JtbrL"};